<mat-form-field>
    <mat-select [formControl]="recipientsCtrl" [placeholder]="'kudos.card.recipients.placeholder_edit' | translate" [hideSingleSelectionIndicator]="true">
        <mat-option>
            <ngx-mat-select-search [formControl]="recipientFilterCtrl"
                                   [placeholderLabel]="'kudos.activity-modal.search_kudos_recipient' | translate">
                <mat-icon class="clear-search-icon" ngxMatSelectSearchClear fontSet="fa" fontIcon="fa-times"></mat-icon>
            </ngx-mat-select-search>
        </mat-option>
        <mat-option [value]="ALL_THE_TEAM"><i class="fa-light fa-users"></i> {{ 'kudos.card.recipient.all' | translate}}</mat-option>
        <mat-divider [inset]="true"></mat-divider>
        @for (recipient of filteredRecipientList; track recipient) {
        <mat-option [value]="recipient"><i class="fa-light fa-user"></i> {{recipient.fullname}}</mat-option>
        }
    </mat-select>
</mat-form-field>

<div class="kudos-recipient-chips">
    @for(selectedRecipent of selectedRecipients; track selectedRecipent){
        <mat-chip-row class="blue-chip-row" (removed)="removeRecipient(selectedRecipent)">
            @if(selectedRecipent.id === 'all'){
                {{ 'kudos.card.recipient.all' | translate}}
            }@else{
                {{selectedRecipent.fullname}}
            }
            <button matChipRemove [attr.aria-label]="'remove ' + selectedRecipent.fullname">
                <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
            </button>
        </mat-chip-row>
    }
</div>
